import { Values } from '../interfaces';

export enum BankAccountsActionType {
  GET_BANK_ACCOUNTS = 'GET_BANK_ACCOUNTS',
  GET_BANK_ACCOUNTS_SUCCESS = 'GET_BANK_ACCOUNTS_SUCCESS',
  GET_BANK_ACCOUNTS_ERROR = 'GET_BANK_ACCOUNTS_ERROR',
  SHOW_NEW_BANK_ACCOUNT = 'SHOW_NEW_BANK_ACCOUNT',
  GET_BANKS_FOR_BANK_ACCOUNTS = 'GET_BANKS_FOR_BANK_ACCOUNTS',
  GET_BANKS_FOR_BANK_ACCOUNTS_SUCCESS = 'GET_BANKS_FOR_BANK_ACCOUNTS_SUCCESS',
  GET_BANKS_FOR_BANK_ACCOUNTS_ERROR = 'GET_BANKS_FOR_BANK_ACCOUNTS_ERROR',
  ADD_BANK_ACCOUNT = 'ADD_BANK_ACCOUNT',
  ADD_BANK_ACCOUNT_SUCCESS = 'ADD_BANK_ACCOUNT_SUCCESS',
  ADD_BANK_ACCOUNT_ERROR = 'ADD_BANK_ACCOUNT_ERROR',
  EDIT_BANK_ACCOUNT = 'EDIT_BANK_ACCOUNT',
  EDIT_BANK_ACCOUNT_SUCCESS = 'EDIT_BANK_ACCOUNT_SUCCESS',
  EDIT_BANK_ACCOUNT_ERROR = 'EDIT_BANK_ACCOUNT_ERROR',
}

export const getBankAccounts = (page?: number, statusFilter?: string) => ({
  type: BankAccountsActionType.GET_BANK_ACCOUNTS,
  page,
  statusFilter,
});

export const getBankAccountsSuccess = (response: any) => ({
  type: BankAccountsActionType.GET_BANK_ACCOUNTS_SUCCESS,
  response,
});

export const getBankAccountsError = (error: any) => ({
  type: BankAccountsActionType.GET_BANK_ACCOUNTS_ERROR,
  error,
});

export const showBankAccount = (show: boolean) => ({
  type: BankAccountsActionType.SHOW_NEW_BANK_ACCOUNT,
  show,
});

export const getBanksForBankAccounts = (country: string) => ({
  type: BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS,
  country,
});

export const getBanksForBankAccountsSuccess = (response: any) => ({
  type: BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS_SUCCESS,
  response,
});

export const getBanksForBankAccountsError = (error: any) => ({
  type: BankAccountsActionType.GET_BANKS_FOR_BANK_ACCOUNTS_ERROR,
  error,
});

export const addBankAccount = (values: Values, isStep2?: boolean) => ({
  type: BankAccountsActionType.ADD_BANK_ACCOUNT,
  values,
  isStep2
});

export const addBankAccountSuccess = (response: any) => ({
  type: BankAccountsActionType.ADD_BANK_ACCOUNT_SUCCESS,
  response,
});

export const addBankAccountError = (error: any) => ({
  type: BankAccountsActionType.ADD_BANK_ACCOUNT_ERROR,
  error,
});

export const sendEditBankAccount = (id: string, values: Values) => ({
  type: BankAccountsActionType.EDIT_BANK_ACCOUNT,
  id,
  values,
});

export const sendEditBankAccountSuccess = (response: any) => ({
  type: BankAccountsActionType.EDIT_BANK_ACCOUNT_SUCCESS,
  response,
});

export const sendEditBankAccountError = (error: any) => ({
  type: BankAccountsActionType.EDIT_BANK_ACCOUNT_ERROR,
  error,
});
